<template>
  <v-container>
    <v-form @submit.prevent="addTrip" ref="form">
      <h2 class="display-2" v-if="!itinerary">Add itinerary</h2>
      <h2 class="display-2" v-if="itinerary">Edit itinerary</h2>

      <v-text-field
        label="Travefy link"
        v-model="newTrip.travefyLink"
        required
        :rules="[v => !!v || 'Required field']"
      ></v-text-field>
      <v-text-field
        label="Image link"
        v-model="newTrip.imageLink"
        required
        :rules="[v => !!v || 'Required field']"
      ></v-text-field>
      <v-text-field
        label="Name"
        v-model="newTrip.name"
        required
        :rules="[v => !!v || 'Required field']"
      ></v-text-field>
      <v-text-field
        label="Destination"
        v-model="newTrip.destination"
        required
        :rules="[v => !!v || 'Required field']"
      ></v-text-field>

      <v-layout>
        <v-flex xs12 sm6>
          <h5>Start date</h5>
          <v-date-picker v-model="newTrip.startDate" :landscape="true" :rules="[v => !!v || 'Required field']"></v-date-picker>
        </v-flex>
        <v-flex xs12 sm6>
          <h5>End date</h5>
          <v-date-picker v-model="newTrip.endDate" :landscape="true" :rules="[v => !!v || 'Required field']"></v-date-picker>
        </v-flex>
      </v-layout>

      <v-btn type="submit" color="info">Save</v-btn>
      <v-btn :to="{ name: 'backend-user', params: { id: userId }}" v-if="itinerary">Back</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { Database } from '@/library/firebase'

export default {
  props: {
    userId: String,
    itinerary: Object,
    itineraryId: String
  },
  data () {
    return {
      startDatePicker: false,
      endDatePicker: false,

      newTrip: {
        travefyLink: null,
        imageLink: null,
        name: null,
        destination: null,
        startDate: null,
        endDate: null
      }
    }
  },
  methods: {
    addTrip () {
      if (this.itinerary) {
        return this.saveTrip()
      }

      if (this.$refs.form.validate()) {
        Database.ref('travefyTrips').child(this.userId).push(this.newTrip)
        this.$toasted.success('Trip added!', { duration: 2000 })
        this.$emit('addItinerary', this.newTrip)
      }
    },
    saveTrip () {
      if (this.$refs.form.validate()) {
        Database.ref('travefyTrips').child(this.userId).child(this.itineraryId).set(this.newTrip)

        this.$toasted.success('Saved', { duration: 2000 })
        this.$router.push({ name: 'backend-user', params: { id: this.userId } })
      }
    }
  },
  watch: {
    itinerary () {
      this.newTrip = this.itinerary
    }
  },
  created () {
    if (this.itinerary) {
      this.newTrip = this.itinerary
    }
  }
}
</script>

<style>
</style>
